import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Building2,
  UserPlus,
  Calendar,
  RefreshCcw,
  ChevronRight,
  FileText,
  CheckCircle2,
  Crown,
  Edit,
  Eye,
  Users,
  IndianRupee,
  Bell,
  Settings,
  TrendingUp,
} from "lucide-react";

export default function TempleDashboard() {
  const navigate = useNavigate();
  const [templeData, setTempleData] = useState(null);
  const [loading, setLoading] = useState(true);
  const TEMPLE_PROFILE_KEY = "temple_profile";


  useEffect(() => {
  fetchTempleProfile();
}, []);


  // const fetchTempleProfile = async () => {
  //   try {
  //     setLoading(true);
  //     // TODO: Replace with actual API call
  //     const response = await fetch('/api/temple/profile', {
  //       headers: {
  //         'Authorization': `Bearer ${localStorage.getItem('token')}`
  //       }
  //     });
  const fetchTempleProfile = () => {
  console.log("🔍 Checking temple profile from localStorage");

  const storedProfile = localStorage.getItem(TEMPLE_PROFILE_KEY);

  if (storedProfile) {
    const parsed = JSON.parse(storedProfile);
    console.log("✅ Temple profile found:", parsed);
    setTempleData(parsed);
  } else {
    console.log("❌ No temple profile found");
    setTempleData(null);
  }

  setLoading(false);
};

     

const handleCreateProfile = () => {
  if (templeData) {
    alert("Temple profile already exists. You can only edit it.");
    return;
  }
  navigate("/temple-registration");
};

  const handleEditProfile = () => {
    navigate('/temple-editpage');
  };

  const handleViewPublicProfile = () => {
    navigate(`/temple/view/${templeData?.id}`);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50 pt-20 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-orange-600 font-semibold text-lg">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  const hasProfile = templeData !== null;
  const templeName = templeData?.templeName;

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50 mt-20">
      {/* Header with gradient */}
      <div className="bg-gradient-to-r from-orange-600 via-orange-500 to-red-500 shadow-xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center">
              <Building2 className="w-8 h-8 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-white">
                Welcome {templeName}
              </h1>
              <p className="text-orange-100 mt-1 text-sm">
                Temple Management Dashboard
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
        {/* Profile Status Card */}
        {!hasProfile ? (
          <div className="bg-gradient-to-br from-orange-50 to-red-50 border-2 border-orange-300 rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
              <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-orange-500 to-red-500 flex items-center justify-center flex-shrink-0 shadow-lg">
                <UserPlus className="w-10 h-10 text-white" />
              </div>
              <div className="flex-1">
                <h2 className="text-3xl font-bold text-orange-900 mb-2">
                  Create Your Temple Profile
                </h2>
                <p className="text-orange-700 text-lg mb-4">
                  Set up your temple profile to start receiving booking requests from devotees across the platform.
                </p>
                <div className="flex flex-wrap gap-3">
                  <button
                    onClick={handleCreateProfile}
                    className="px-8 py-3 rounded-xl text-white font-semibold bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5"
                  >
                    Create Profile Now
                  </button>
                 
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 border-2 border-green-300 rounded-3xl p-8 shadow-lg">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
              <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-green-500 to-emerald-500 flex items-center justify-center flex-shrink-0 shadow-lg">
                <CheckCircle2 className="w-10 h-10 text-white" />
              </div>
              <div className="flex-1">
                {/* <h2 className="text-3xl font-bold text-green-900 mb-2">
                  Profile Active 🎉
                </h2> */}
                <p className="text-green-700 text-lg mb-4">
                  Your temple profile is live and visible to devotees. Keep it updated to attract more bookings.
                </p>
                <div className="flex flex-wrap gap-3">
                  <button
                    onClick={handleViewPublicProfile}
                    className="px-6 py-3 rounded-xl text-white font-semibold bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 shadow-md hover:shadow-lg transition-all inline-flex items-center gap-2"
                  >
                    <Eye className="w-5 h-5" />
                    View Public Profile
                  </button>
                 
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Statistics Cards
        {hasProfile && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <StatCard
              title="Total Bookings"
              value="156"
              icon={<Calendar className="w-8 h-8" />}
              color="blue"
              trend="+12%"
            />
            <StatCard
              title="Revenue"
              value="₹45,000"
              icon={<IndianRupee className="w-8 h-8" />}
              color="green"
              trend="+8%"
            />
            <StatCard
              title="Visitors"
              value="1,234"
              icon={<Users className="w-8 h-8" />}
              color="purple"
              trend="+15%"
            />
            <StatCard
              title="Reviews"
              value="4.8"
              icon={<TrendingUp className="w-8 h-8" />}
              color="orange"
              trend="98% positive"
            />
          </div>
        )} */}

        {/* Action Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <ActionCard
            title="Manage Bookings"
            description="View and manage all booking requests"
            icon={<Calendar className="w-10 h-10" />}
            color="blue"
            buttonText="View Bookings"
            onClick={() => navigate('/temple/bookings')}
            disabled={!hasProfile}
          />

          <ActionCard
            title="Manage Bookings"
            description="View and manage all booking requests"
            icon={<Calendar className="w-10 h-10" />}
            color="green"
            buttonText="View Bookings"
            onClick={() => navigate('/temple/bookings')}
            disabled={!hasProfile}
          />

          <ActionCard
            title="Update Profile"
            description="Edit temple information and details"
            icon={<Edit className="w-10 h-10" />}
            color="orange"
            buttonText="Edit Now"
            onClick={handleEditProfile}
            disabled={!hasProfile}
          />

          <ActionCard
            title="Subscription Plan"
            description="Manage your subscription and features"
            icon={<Crown className="w-10 h-10" />}
            color="purple"
            buttonText="View Plans"
            onClick={() => navigate('/temple/subscription')}
          />

         


        </div>

        {/* Help Section */}
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-3xl p-8 shadow-lg">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-500 flex items-center justify-center flex-shrink-0">
              <FileText className="w-8 h-8 text-white" />
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-bold text-blue-900 mb-2">
                Need Help Getting Started?
              </h3>
              <p className="text-blue-700 text-lg mb-4">
                Learn how to optimize your temple profile and attract more devotees with our comprehensive guides.
              </p>
              <button className="px-6 py-3 rounded-xl border-2 border-blue-300 text-blue-700 font-semibold bg-white hover:bg-blue-50 transition-all inline-flex items-center gap-2">
                <FileText className="w-5 h-5" />
                Visit Help Center
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ---------------- STAT CARD COMPONENT ---------------- */
function StatCard({ title, value, icon, color, trend }) {
  const colorClasses = {
    blue: "from-blue-500 to-blue-600",
    green: "from-green-500 to-emerald-600",
    purple: "from-purple-500 to-purple-600",
    orange: "from-orange-500 to-red-500",
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all overflow-hidden">
      <div className={`bg-gradient-to-r ${colorClasses[color]} p-6 text-white`}>
        <div className="flex justify-between items-start mb-4">
          <div>
            <p className="text-white/80 text-sm font-medium">{title}</p>
            <p className="text-3xl font-bold mt-1">{value}</p>
          </div>
          <div className="opacity-80">{icon}</div>
        </div>
        <div className="flex items-center gap-1 text-sm">
          <TrendingUp className="w-4 h-4" />
          <span className="font-semibold">{trend}</span>
        </div>
      </div>
    </div>
  );
}

/* ---------------- ACTION CARD COMPONENT ---------------- */
function ActionCard({ title, description, icon, color, buttonText, onClick, disabled = false }) {
  const colorClasses = {
    blue: "from-blue-500 to-blue-600",
    orange: "from-orange-500 to-red-500",
    purple: "from-purple-500 to-purple-600",
    green: "from-green-500 to-emerald-600",
    red: "from-red-500 to-pink-500",
    gray: "from-gray-500 to-gray-600",
  };

  const textColorClasses = {
    blue: "text-blue-700",
    orange: "text-orange-700",
    purple: "text-purple-700",
    green: "text-green-700",
    red: "text-red-700",
    gray: "text-gray-700",
  };

  return (
    <div
      className={`bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all overflow-hidden ${
        disabled ? "opacity-60" : ""
      }`}
    >
      <div className={`bg-gradient-to-r ${colorClasses[color]} p-6 text-white`}>
        <div className="flex justify-between items-start">
          <h3 className="text-xl font-bold">{title}</h3>
          <div className="opacity-80">{icon}</div>
        </div>
        <p className="text-white/90 mt-3 text-sm">{description}</p>
      </div>
      <button
        onClick={onClick}
        disabled={disabled}
        className={`flex justify-between items-center w-full px-6 py-4 font-semibold ${textColorClasses[color]} ${
          disabled ? "cursor-not-allowed bg-gray-50" : "hover:bg-gray-50"
        } transition-all`}
      >
        <span>{buttonText}</span>
        <ChevronRight className="w-5 h-5" />
      </button>
    </div>
  );
}